import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from 'src/app/models/api-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserMediaService {
  private readonly baseUrl = `${environment.welbyEndpoint}/api/v1/users`;

  constructor(private http: HttpClient) {}

  /** Uploads the signed-in user's own signature (PNG); the server derives the key from the session. */
  uploadSignature(file: File): Observable<{ signatureKey: string }> {
    return this.http
      .put<ApiResponse<{ signatureKey: string }>>(`${this.baseUrl}/me/signature`, this.formWith(file))
      .pipe(map((res) => res.data));
  }

  /** Uploads the signed-in user's own profile photo; it is shown through presigned links, not a stored URL. */
  uploadProfilePhoto(file: File): Observable<{ profileImageKey: string }> {
    return this.http
      .put<ApiResponse<{ profileImageKey: string }>>(`${this.baseUrl}/me/profile-photo`, this.formWith(file))
      .pipe(map((res) => res.data));
  }

  /** Asks the API for a short-lived link to a clinician's signature. */
  getSignatureUrl(userId: string): Observable<string> {
    return this.http
      .get<ApiResponse<{ url: string }>>(`${this.baseUrl}/${encodeURIComponent(userId)}/signature/url`)
      .pipe(map((res) => res.data.url));
  }

  private formWith(file: File): FormData {
    const formData = new FormData();
    formData.append('file', file);
    return formData;
  }
}
